/**
 * The backend's user roles. A user has exactly ONE role (the backend's
 * `role`/`type` field). Ported from cpanel `USER_ROLES`. UI access is NOT
 * decided by role — it comes from the user's granted permission keys
 * (`entities/access`); the role only drives role-specific behaviour (e.g. the
 * call-center search alarm).
 */
export const ROLES = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  IBOX_MANAGER: 'IBOX_MANAGER',
  AF_MANAGER: 'AF_MANAGER',
  AF_ADMIN: 'AF_ADMIN',
  B2B_BACK: 'B2B_BACK',
  B2B_FRONT: 'B2B_FRONT',
  B2B_HEAD: 'B2B_HEAD',
  CALL_CENTER: 'CALL_CENTER',
  AF_CALL_CENTER: 'AF_CALL_CENTER',
  ACCOUNTANT: 'ACCOUNTANT',
  XOLODILNIK: 'XOLODILNIK',
  TRANSLATOR: 'TRANSLATOR',
  OPS_ADMIN: 'OPS_ADMIN',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/** All role values, for validation. */
export const ALL_ROLES = Object.values(ROLES);
